export default __webpack_public_path__ + "static/media/logo-white.d9c85040.ico";